import { Platform } from "react-native";
import { useConfig } from "../hooks/useConfig";

export const redirectToAuthUI = async () => {
  const currentURL = window.location.host;

  if (!currentURL.includes("localhost") && Platform.OS === "web") {
    const config = useConfig();
    let redirectURL = config.authUiBaseUrl;

    if (window.location.pathname) {
      redirectURL += `?redirect_uri=${window.location.pathname}`;
    }

    window.location.href = redirectURL;
  }
};
